import React from 'react';
import { Box } from '@mui/material';

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`project-tabpanel-${index}`}
    aria-labelledby={`project-tab-${index}`}
    {...other}
  >
    {value === index && (
      <Box sx={{ p: { xs: 1.5, sm: 2.5 }, pb: { xs: 4, sm: 6 } }}>{children}</Box>
    )}
  </div>
);

export default TabPanel;
